import type { FissionFund } from '../../cms_types'

export const fund_symbols = ['XPE'] as const
export type FundSymbol = (typeof fund_symbols)[number]

export const simulated_fund_symbols = [
  'XVC',
  'XUC',
  // 'XARK',
  // 'XAPO',
  // 'XTEC',
  // 'XBLK',
  // 'XFIN',
  // 'XCON',
  // 'XIND',
  // 'XSFT',
  // 'XAID',
] as const
export type SimulatedFundSymbol = (typeof simulated_fund_symbols)[number]

export const all_fund_symbols = [
  ...simulated_fund_symbols,
  ...fund_symbols,
] as const
export type AllFundSymbol = FundSymbol | SimulatedFundSymbol

const standard_fission_data: Pick<
  FissionFund,
  'is_fission_etf' | 'investor_geographies' | 'investor_classes'
> = {
  is_fission_etf: true,
  investor_geographies: ['non-US'],
  investor_classes: ['Qualified', 'Accredited'],
}

const fund_meta: Record<AllFundSymbol, Omit<FissionFund, 'metrics'>> = {
  XVC: {
    ...standard_fission_data,
    name: 'Fission VC ETF',
    short_name: 'XVC ETF',
    symbol: 'XVC',
    asset_categories: ['Venture Capital'],
    strategy_brief: 'VC Fund of Funds',
    fund_strategy:
      'Token VC is a fund of funds focused on gaining access to top-tier venture capital and growth equity opportunities. By investing in a curated portfolio of leading venture funds, often referred to as “venture secondaries” or “venture secretaries”. Token VC provides diversified exposure to the innovation economy, backing some of the most promising private companies through experienced fund managers.',
  },
  XPE: {
    ...standard_fission_data,
    name: 'Fission Technology SPC Fund',
    short_name: 'XPE Fund',
    symbol: 'XPE',
    asset_categories: ['Private Equity'],
    strategy_brief: 'PE Fund of Funds',
    fund_strategy:
      'Token PE is a fund of funds focused on gaining access to top-tier private equity opportunities. By investing in a curated portfolio of leading pe funds, often referred to as “venture secondaries” or “venture secretaries”. Token PE provides diversified exposure to the innovation economy, backing some of the most promising private companies through experienced fund managers.',
  },
  XUC: {
    ...standard_fission_data,
    name: 'Fission Unicorn ETF',
    short_name: 'XUC ETF',
    symbol: 'XUC',
    asset_categories: ['Unicorns'],
    strategy_brief: 'VC Unicorns Fund',
    fund_strategy:
      'The technology fund contains VC-backed private companies revolutionizing their respective markets. Learn more about the fund and portfolio companies below.',
  },
  // XARK: {
  //   strategy_brief: 'Tech VC & Public Companies',
  //   fund_strategy: 'TODO',
  // },
  // XAPO: {
  //   strategy_brief: 'Private Market Secondaries',
  //   fund_strategy: 'TODO',
  // },
  // XAID: {
  //   strategy_brief: 'AI & Data VC Companies',
  //   fund_strategy:
  //     'The AI & Data fund contains VC-backed private companies revolutionizing the AI & Data markets. Learn more about the fund and portfolio companies below.',
  // },
  // XSFT: {
  //   strategy_brief: 'Software VC Companies',
  //   fund_strategy:
  //     'The software fund contains VC-backed private companies revolutionizing the software markets. Learn more about the fund and portfolio companies below.',
  // },
  // XIND: {
  //   strategy_brief: 'Industrial VC Companies',
  //   fund_strategy:
  //     'The industrial fund contains VC-backed private companies revolutionizing the industrial markets. Learn more about the fund and portfolio companies below.',
  // },
  // XCON: {
  //   strategy_brief: 'Consumer VC Companies',
  //   fund_strategy:
  //     'The customer fund contains VC-backed private companies revolutionizing the customer markets. Learn more about the fund and portfolio companies below.',
  // },
  // XFIN: {
  //   strategy_brief: 'Financial VC Companies',
  //   fund_strategy:
  //     'The FinTech fund contains VC-backed private companies revolutionizing the financial markets. Learn more about the fund and portfolio companies below.',
  // },
  // XTEC: {
  //   strategy_brief: 'Technology VC Companies',
  //   fund_strategy:
  //     'The technology fund contains VC-backed private companies revolutionizing their respective markets. Learn more about the fund and portfolio companies below.',
  // },
  // XBLK: {
  //   strategy_brief: 'Blockchain VC Companies',
  //   fund_strategy:
  //     'The Blockchain fund contains VC-backed private companies revolutionizing the blockchain markets. Learn more about the fund and portfolio companies below.',
  // },
}
export default fund_meta
